import {ErrorFlow} from 'olympe';

/**
 * Static class that control materials.
 */
class PSLController {
    /**
     *
     * @param {BrickContext} $
     * @param {} getPSLBrick
     * @param {string} materialCodeParam
     * @param {string} skipParam
     * @param {string} takeParam
     * @param {string} companyCodeParam
     * @return {Promise<{mtart: string}[]>}
     */
    getPSLRequest($, getPSLBrick, materialCodeParam, skipParam, takeParam, companyCodeParam) {
        return new Promise((resolve, reject) => {
            const [
                controlFlowIn,
                materialCodeKey,
                skipKey,
                takeKey,
                companyCodeKey,
            ] = getPSLBrick.getInputs();

            const [
                SuccessOut,
                ErrorOut,
                statusCodeOut,
                resultOut,
            ] = getPSLBrick.getOutputs();

            const getPSLRequestRunner = $.runner(getPSLBrick)
                .set(materialCodeKey, materialCodeParam)
                .set(skipKey, skipParam)
                .set(takeKey, takeParam)
                .set(companyCodeKey, companyCodeParam)
                .trigger(controlFlowIn);

            Promise.any([
                getPSLRequestRunner.waitFor(SuccessOut),
                getPSLRequestRunner.waitFor(ErrorOut),
            ]).then((outputFlow) => {
                const response = getPSLRequestRunner.get(resultOut);
                if (outputFlow instanceof ErrorFlow && !response?.includes('Psl Entries not Found') ) {
                    reject(outputFlow);
                } else {
                    resolve({
                        response: response?.error?.includes('Psl Entries not Found') ? [] : JSON.parse(response),
                        status: JSON.parse(getPSLRequestRunner.get(statusCodeOut)),
                    });
                }
            }).catch(reject)
                .finally(() => getPSLRequestRunner.destroy());
        });
    }
}

// Singleton
export default new PSLController();
